<ul class="no-bullets trigger-info-list"
    *uiContentLoading="loading$ | async; diameter: 75">
    <li class="trigger-info"
        *ngIf="item?.release">
        <span class="label">{{ 'job_trigger_detail_job_process' | translate }}</span>
        <span class="value">{{ item?.release?.processKey }}</span>
    </li>
    <li class="trigger-info"
        *ngIf="item?.robot">
        <span class="label">{{ 'job_trigger_detail_job_robot' | translate }}</span>
        <span class="value">{{ item?.robot?.name }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_job_environment' | translate }}</span>
        <span class="value">{{ item?.environmentName }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_job_state' | translate }}</span>
        <span class="value">{{ item?.state }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_job_started_at' | translate }}</span>
        <span class="value">
            <ui-dateformat [date]="item?.startTime"
                           contentType="relative">
            </ui-dateformat>
        </span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_job_source' | translate }}</span>
        <span class="value">
            <ng-container *ngIf="[JobSource.Schedule, JobSource.Queue]
                            .includes(JobSource[item?.sourceType]);
                        else sourceType">
                {{ item?.source }}
            </ng-container>
            <ng-template #sourceType>
                <ng-container *ngLet="('JobSource_' + item?.sourceType | translate) as sourceType">
                    {{ sourceType }}
                </ng-container>
            </ng-template>
        </span>
    </li>
</ul>
